import * as React from 'react';
import {
    TextField,
    Button,
    Container,
    Box,
    Typography,
} from '@mui/material';
import Navbar from '../setup/Navbar';
import StickyTable from '../../BuiltInComponent/TableWithPagination';
import Footer from '../setup/Footer';
import Loading from '../../BuiltInComponent/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { getUnits, getSingleUnits, addUnit, editUnit, deleteUnit } from '../../features/AdminManagement/unitsSlice';
const UnitsForm = () => {

    const dispatch = useDispatch();

    const { units, isLoading } = useSelector((state) => state.units);

    const tableColumns = [
        { fieldName: 'unitID', cName: 'unitID', textAlign: 'right', dType: 'string', status: 'en' },
        { fieldName: 'unitDescription', cName: 'Units Description', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'Edit', cName: 'Edit', width: 50, textAlign: 'center', dType: 'string', status: 'en' },
        { fieldName: 'Delete', cName: 'Delete', width: 50, textAlign: 'center', dType: 'string', status: 'en' },
        { fieldName: 'Delete', cName: 'Delete', width: 50, textAlign: 'center', dType: 'string', status: 'dis' },
    ]

    React.useEffect(() => {
        dispatch(getUnits())
    }, [dispatch]);

    const [unitsData, setUnitsData] = React.useState({
        unitID: '',
        unitDescription: '',
        unitStatus: true,
    });

    const handleChange = (e) => {
        setUnitsData({
            ...unitsData,
            [e.target.name]: e.target.value,
        });
    };

    const onEditClick = async (id) => {
        dispatch(getSingleUnits(id)).then((res) => {
            setUnitsData({
                ...unitsData,
                unitID: res.payload.unitID,
                unitDescription: res.payload.unitDescription,
                unitStatus: res.payload.unitStatus,
            })
        })
    }
    const onDeleteClick = async (id) => {
        dispatch(deleteUnit(id)).then(() => {
            dispatch(getUnits())
        })
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (unitsData.unitID === '') {
            dispatch(addUnit(unitsData)).then(() => {
                dispatch(getUnits())
            })
        } else {
            dispatch(editUnit(unitsData)).then(() => {
                dispatch(getUnits())
            })
        }
    };

    return (
        <>
            <Navbar />
            <Container maxWidth='sm'>
                <Box sx={{ background: 'linear-gradient(90deg, rgba(16,191,248,1) 0%, rgba(12,150,180,1) 100%)', mb: 3, borderRadius: 2, color: 'white', textShadow: 'black 4px 4px 10px' }}>
                    <Typography sx={{ textAlign: 'center', fontSize: 30, fontWeight: 'bolder' }}> Units</Typography>
                </Box>
                <TextField
                    id="outlined-basic"
                    label="Unit Description"
                    variant="outlined"
                    name="unitDescription"
                    value={unitsData.unitDescription}
                    onChange={handleChange}
                    fullWidth
                />
                <Button variant='contained' fullWidth sx={{ mt: 2, color: 'white', fontSize: 20, fontWeight: 'bolder' }} onClick={handleSubmit}>SAVE</Button>
                {isLoading ?
                    <>
                        <Loading />
                    </>
                    :
                    <>
                        <StickyTable
                            tableColumns={tableColumns}
                            tableData={units && units}
                            onEditClick={onEditClick}
                            onDeleteClick={onDeleteClick} />
                    </>}
            </Container>
            <Footer />
        </>
    );
};

export default UnitsForm;
